module.exports = __webpack_public_path__ + "SamsungOne-600.9c943d26ff36f2476cd2.ttf";


//////////////////
// WEBPACK FOOTER
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/assets/layout/fonts/SamsungOne-600.ttf
// module id = ../../../../../src/assets/layout/fonts/SamsungOne-600.ttf
// module chunks = styles